import React from 'react';

import PropTypes from 'prop-types';

import {
  Modal,
  ModalBody,
  ModalHeader,
} from 'reactstrap';
import { Button } from 'components/Button';

const CancelPaymentModal = ({ isOpen, toggle, className, showCloseBtn, paddingTop, footerLink }) => (
  <Modal wrapClassName={className} isOpen={isOpen} toggle={toggle}>
    <ModalHeader className="no-border" toggle={toggle}>How can I cancel my payment?</ModalHeader>
    <ModalBody className={`pt-${paddingTop} recurring-description`}>
      <p>To cancel a scheduled payment, please call us at (888) 502-8082 before the Payment Date shown above. Payments cannot be cancelled on or after the Payment Date.</p>
      {showCloseBtn ? (
        <>
          <Button className="w-100" color="primary" onClick={toggle}>Close</Button>
          {footerLink}
        </>
      ) : null}
    </ModalBody>
  </Modal>
);

CancelPaymentModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  className: PropTypes.string,
  showCloseBtn: PropTypes.bool,
  paddingTop: PropTypes.number,
  footerLink: PropTypes.node,
};

CancelPaymentModal.defaultProps = {
  className: '',
  showCloseBtn: false,
  paddingTop: 3,
  footerLink: '',
};

export default CancelPaymentModal;
